import C0822Validator from 'shared/ncts/p5/conditions/C0822'
import C0823Validator from 'shared/ncts/p5/conditions/C0823'
import C0839Validator from 'shared/ncts/p5/conditions/C0839'
import C0191Validator from 'shared/ncts/p5/conditions/C0191'
import C0599Validator from 'shared/ncts/p5/conditions/C0599'
import C0387Validator from 'shared/ncts/p5/conditions/C0387'
import C0101Validator from 'shared/ncts/p5/conditions/C0101'
import C0587Validator from 'shared/ncts/p5/conditions/C0587'
import C0598Validator from 'shared/ncts/p5/conditions/C0598'
import C0670Validator from 'shared/ncts/p5/conditions/C0670'
import C0055Validator from 'shared/ncts/p5/conditions/C0055'
import C0671Validator from 'shared/ncts/p5/conditions/C0671'
import C0394Validator from 'shared/ncts/p5/conditions/C0394'
import NC0035Validator from 'shared/ncts/FI/NC0035'
import NC9012Validator from 'shared/ncts/FI/NC9012'
import C0505Validator from 'shared/ncts/p5/conditions/C0505'
import NC9043Validator from 'shared/ncts/FI/NC9043'
import C0710Validator from 'shared/ncts/p5/conditions/C0710'
import C0382Validator from 'shared/ncts/p5/conditions/C0382'
import C0250Validator from 'shared/ncts/p5/conditions/C0250'
import C0531Validator from 'shared/ncts/p5/conditions/C0531'
import C0806Validator from 'shared/ncts/p5/conditions/C0806'
import C0586Validator from 'shared/ncts/p5/conditions/C0586'
import CustomValidators from 'shared/ncts/validation'
import C0826Validator from 'shared/ncts/p5/conditions/C0826'
import { NctsCountry, supportsPreLodgedDeclaration } from 'config'
import { FieldRequirementResolverContext } from '../types'
import { createFieldRequirementGetter, matchServerRequirement } from '../../../resolverFactory'
import {
  FieldRequirement,
  FieldRequirementEnvironment,
  FieldRequirementResolverMap,
  forbidden, optional, required,
  toFieldRequirement,
} from '../../../../../../models/fieldRules'
import C0403Validator from '../../../../../../../../shared/ncts/p5/conditions/C0403'
import C0001Validator from '../../../../../../../../shared/ncts/p5/conditions/C0001_server'
import { isConsigneePresent } from '../../../../../../../../shared/ncts/common/types'

function ruleForAdditionalDeclarationType(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return supportsPreLodgedDeclaration(ctx.country as NctsCountry) ? 'required' : 'forbidden'
}

function ruleForReferenceNumberUCR(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return ctx.country === 'FI' ? 'required' : 'optional'
}

function ruleForContainerIndicator(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0822Validator.validateContainerIndicatorRequirement(ctx))
}

function ruleForTransportEquipment(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0823Validator.validateTransportEquipmentRequirement(ctx))
}

function ruleForLimitDate(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0839Validator.validateLimitDateRequirement(ctx))
}

function ruleForBorderModeOfTransport(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  return toFieldRequirement(C0599Validator.validateModeOfTransportAtBorderRequirement(ctx))
}

function ruleForLoading(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0403Validator.validatePlaceOfLoadingRequirement(ctx))
}

function ruleForPlaceOfLoadingLocation(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0387Validator.validateCountryAndLocationRequirement(ctx.placeOfLoading?.unLocode ?? ''))
}

function ruleForPlaceOfLoadingCountry(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0387Validator.validateCountryAndLocationRequirement(ctx.placeOfLoading?.unLocode ?? ''))
}

function ruleForUnloading(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0191Validator.validatePlaceOfUnloadingRequirement(ctx.security))
}

function ruleForPlaceOfUnloadingLocation(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0387Validator.validateCountryAndLocationRequirement(ctx.placeOfUnloading?.unLocode ?? ''))
}

function ruleForPlaceOfUnloadingCountry(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0387Validator.validateCountryAndLocationRequirement(ctx.placeOfUnloading?.unLocode ?? ''))
}

function ruleForAuthorisations(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0101Validator.validateAuthorisationRequirement(ctx.reducedDatasetIndicator))
}

function ruleForCustomsOfficesOfTransitExit(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0587Validator.validateTransitExitCustomsOfficeRequirement(ctx))
}

function ruleForTransitCustomsOfficeDateTime(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0598Validator.validateTransitOfficeDateTimeRequirement(ctx))
}

function ruleForGoodsReferences(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0670Validator.validateGoodsReferenceRequirement(ctx))
}

function ruleForContainerIdentificationNumber(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  return toFieldRequirement(C0055Validator.isContainerIdentificationNumberRequired(ctx))
}

function ruleForLocationOfGoods(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  if (ctx.locationOfGoods?.typeOfLocation) return 'required'

  if (ctx.country === 'FI') {
    return toFieldRequirement(NC9043Validator.validateLocationOfGoodsRequirement(ctx))
  }

  return toFieldRequirement(C0710Validator.validateLocationOfGoodsRequirement(ctx))
}

function ruleForLocationOfGoodsAuthorisationNumber(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  return toFieldRequirement(C0394Validator.validateAuthorisationNumberRequirement(ctx))
}

function ruleForLocationOfGoodsAdditionalIdentifier(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  if (ctx.country === 'FI') return 'forbidden'
  return toFieldRequirement(C0671Validator.validateAdditionalIdentifierRequirement(ctx))
}

function ruleForLocationOfGoodsEconomicOperatorIdentificationNumber(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  const { ctx } = env

  if (ctx.country === 'FI') {
    return toFieldRequirement(NC0035Validator.validateEconomicOperatorRequirement(ctx))
  }

  return toFieldRequirement(C0394Validator.validateEconomicOperatorRequirement(ctx))
}

function ruleForLocationOfGoodsGnss(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  return toFieldRequirement(C0394Validator.validateGnssRequirement(ctx))
}

function ruleForLocationOfGoodsQualifierOfIdentification(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  const { ctx } = env

  if (ctx.country === 'FI') return 'forbidden'

  return ctx.locationOfGoods?.typeOfLocation ? 'required' : 'forbidden'
}

function ruleForLocationOfGoodsContactPerson(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const qualifierOfIdentificationRequirement = env.getFieldRequirement('locationOfGoods.qualifierOfIdentification')
  if (qualifierOfIdentificationRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0394Validator.validateContactPersonRequirement(ctx))
}

function ruleForLocationOfGoodsAddress(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  if (ctx.country === 'FI') {
    return toFieldRequirement(NC9012Validator.validateAddressRequirement(ctx))
  }

  const qualifierOfIdentificationRequirement = env.getFieldRequirement('locationOfGoods.qualifierOfIdentification')
  if (qualifierOfIdentificationRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0394Validator.validateAddressRequirement(ctx))
}

function ruleForLocationOfGoodsAddressAddressLine(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  if (!ctx.locationOfGoods?.address) return 'forbidden'

  return ruleForLocationOfGoodsAddress(env)
}

function ruleForLocationOfGoodsAddressCity(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  if (!ctx.locationOfGoods?.address) return 'forbidden'

  return ruleForLocationOfGoodsAddress(env)
}

function ruleForLocationOfGoodsAddressCountry(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  if (!ctx.locationOfGoods?.address) return 'forbidden'

  return ruleForLocationOfGoodsAddress(env)
}

function ruleForLocationOfGoodsAddressPostcode(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  if (!ctx.locationOfGoods?.address) return 'forbidden'

  const parentRequirement = env.getFieldRequirement('locationOfGoods.address')
  if (parentRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0505Validator.validatePostcodeRequirement(ctx?.locationOfGoods?.address?.country))
}

function ruleForLocationOfGoodPostcodeAddress(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const qualifierOfIdentificationRequirement = env.getFieldRequirement('locationOfGoods.qualifierOfIdentification')
  if (qualifierOfIdentificationRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0394Validator.validatePostCodeAddressRequirement(ctx))
}

function ruleForLocationOfGoodPostcodeAddressHouseNumber(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  const { ctx } = env

  const parentRequirement = env.getFieldRequirement('locationOfGoods.postcodeAddress')
  if (parentRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0382Validator.validateHouseNumberRequirement(ctx))
}

function ruleForLocationOfGoodsReferenceNumber(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  if (ctx.country === 'FI') return 'forbidden'

  const qualifierOfIdentificationRequirement = env.getFieldRequirement('locationOfGoods.qualifierOfIdentification')
  if (qualifierOfIdentificationRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0394Validator.validateCustomsOfficeRequirement(ctx))
}

function ruleForLocationOfGoodsTypeOfLocation(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  return ctx.locationOfGoods?.typeOfLocation ? 'required' : 'optional'
}

function ruleForLocationOfGoodsUnLocode(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  if (ctx.country === 'FI') return 'forbidden'

  const qualifierOfIdentificationRequirement = env.getFieldRequirement('locationOfGoods.qualifierOfIdentification')
  if (qualifierOfIdentificationRequirement === 'forbidden') return 'forbidden'

  return toFieldRequirement(C0394Validator.validateUnLocodeRequirement(ctx))
}

function ruleForConsignee(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  const ruleConditions = ctx.serverValidationResult?.ruleConditions

  return toFieldRequirement(
    C0001Validator.validateConsignmentConsigneeRequirement({
      isConsignmentConsigneePresent: isConsigneePresent(ctx.consignee),
      hasConsignmentAdditionalReference30600: !!ruleConditions?.hasConsignmentAdditionalReference30600,
      hasHouseConsignmentAdditionalReference30600: !!ruleConditions?.hasHouseConsignmentAdditionalReference30600,
    }),
  )
}

function ruleForConsigneeAddress(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  const consigneeRequirement = env.getFieldRequirement('consignee')
  if (consigneeRequirement === 'forbidden') return 'forbidden'
  if (ctx.country === 'RO') return consigneeRequirement ?? 'optional'

  const requirement = toFieldRequirement(C0250Validator.validateNameAndAddressRequirement(ctx.consignee?.identificationNumber))

  return consigneeRequirement === 'optional' ? 'optional' : requirement
}

function ruleForConsigneeName(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  const consigneeRequirement = env.getFieldRequirement('consignee')
  if (consigneeRequirement === 'forbidden') return 'forbidden'
  if (ctx.country === 'RO') return consigneeRequirement ?? 'optional'

  const requirement = toFieldRequirement(C0250Validator.validateNameAndAddressRequirement(ctx.consignee?.identificationNumber))

  return consigneeRequirement === 'optional' ? 'optional' : requirement
}

function ruleForConsigneeAddressPostcode(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  const addressRequirement = env.getFieldRequirement('consignee.address')
  if (addressRequirement === 'forbidden') return 'forbidden'

  const requirement = toFieldRequirement(C0505Validator.validatePostcodeRequirement(ctx.consignee?.address?.country))

  return addressRequirement === 'optional' ? 'optional' : requirement
}

function ruleForConsignor(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return ctx?.consignor ? 'required' : 'optional'
}

function ruleForConsignorAddress(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  const consignorRequirement = env.getFieldRequirement('consignor')
  if (consignorRequirement === 'forbidden') return 'forbidden'
  if (ctx.country === 'RO') return consignorRequirement ?? 'optional'

  const requirement = toFieldRequirement(C0250Validator.validateNameAndAddressRequirement(ctx.consignor?.identificationNumber))

  return consignorRequirement === 'optional' ? 'optional' : requirement
}

function ruleForConsignorName(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  const consignorRequirement = env.getFieldRequirement('consignor')
  if (consignorRequirement === 'forbidden') return 'forbidden'
  if (ctx.country === 'RO') return consignorRequirement ?? 'optional'

  const requirement = toFieldRequirement(C0250Validator.validateNameAndAddressRequirement(ctx.consignor?.identificationNumber))

  return consignorRequirement === 'optional' ? 'optional' : requirement
}

function ruleForConsignorAddressPostcode(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  const addressRequirement = env.getFieldRequirement('consignor.address')
  if (addressRequirement === 'forbidden') return 'forbidden'

  const requirement = toFieldRequirement(C0505Validator.validatePostcodeRequirement(ctx.consignor?.address?.country))

  return addressRequirement === 'optional' ? 'optional' : requirement
}

function ruleForCarrierContactPerson(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return CustomValidators.validateContactPersonNameAndPhoneRequirement(ctx.carrier?.contactPerson) ? 'required' : 'optional'
}

function ruleForActiveBorderTransportMeans(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0806Validator.validateBorderTransportMeansRequirement(ctx))
}

function ruleForActiveBorderTransportMeansConveyanceReferenceNumber(
  env: FieldRequirementEnvironment<FieldRequirementResolverContext>,
): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0531Validator.validateBorderTransportMeansConveyanceReferenceNumberRequirement(ctx))
}

function ruleForCountryOfRoutingOfConsignment(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0586Validator.validateCountryOfRoutingRequirement(ctx))
}

function ruleForDepartureTransportMeans(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return toFieldRequirement(C0826Validator.validateDepartureTransportMeansForConsignmentRequirement(ctx))
}

const fieldRequirementResolversP5: FieldRequirementResolverMap<FieldRequirementResolverContext> = {
  activeBorderTransportMeans: ruleForActiveBorderTransportMeans,
  'activeBorderTransportMeans.*.conveyanceReferenceNumber': ruleForActiveBorderTransportMeansConveyanceReferenceNumber,
  'activeBorderTransportMeans.*.nationality': optional,
  'activeBorderTransportMeans.*.typeOfMeansOfTransport': forbidden,
  'activeBorderTransportMeans.*.estimatedDateAndTimeOfDeparture': forbidden,
  'activeBorderTransportMeans.*.actualDateAndTimeOfDeparture': forbidden,
  'activeBorderTransportMeans.*.estimatedDateAndTimeOfArrival': forbidden,
  'activeBorderTransportMeans.*.countriesOfRouting': forbidden,
  additionalDeclarationType: ruleForAdditionalDeclarationType,
  additionalInformation: forbidden,
  additionalReference: forbidden,
  authorisations: ruleForAuthorisations,
  borderModeOfTransport: ruleForBorderModeOfTransport,
  carrier: optional,
  'carrier.contactPerson': ruleForCarrierContactPerson,
  'carrier.contactPerson.email': optional,
  'carrier.address': forbidden,
  'carrier.name': required,
  consignee: ruleForConsignee,
  'consignee.id': optional,
  'consignee.contactPerson': forbidden,
  'consignee.identificationNumber': optional,
  'consignee.typeOfPerson': forbidden,
  'consignee.address': ruleForConsigneeAddress,
  'consignee.address.postcode': ruleForConsigneeAddressPostcode,
  'consignee.address.street': forbidden,
  'consignee.address.streetNumber': forbidden,
  'consignee.name': ruleForConsigneeName,
  consignor: ruleForConsignor, // server-side should overwrite this
  'consignor.id': optional,
  'consignor.contactPerson': forbidden,
  'consignor.identificationNumber': optional,
  'consignor.typeOfPerson': forbidden,
  'consignor.address': ruleForConsignorAddress,
  'consignor.address.postcode': ruleForConsignorAddressPostcode,
  'consignor.address.street': forbidden,
  'consignor.address.streetNumber': forbidden,
  'consignor.name': ruleForConsignorName,
  containerIndicator: ruleForContainerIndicator,
  countryOfRoutingOfConsignment: ruleForCountryOfRoutingOfConsignment,
  'countryOfRoutingOfConsignment.*.country': required,
  customsOfficesOfTransitExit: ruleForCustomsOfficesOfTransitExit,
  'customsOfficesOfTransitExit.*.referenceNumber': required,
  departureCustomsOffice: required,
  departureTransportMeans: ruleForDepartureTransportMeans,
  'departureTransportMeans.*.typeOfIdentification': required,
  'departureTransportMeans.*.identificationNumber': required,
  'departureTransportMeans.*.nationality': required,
  destinationCustomsOffice: required,
  entryIndicator: forbidden,
  grossMass: required,
  'guarantee.id': optional,
  'guarantee.nctsProfileId': required,
  'guarantee.amount': required,
  limitDate: ruleForLimitDate,
  locationOfGoods: ruleForLocationOfGoods,
  'locationOfGoods.authorisationNumber': ruleForLocationOfGoodsAuthorisationNumber,
  'locationOfGoods.additionalIdentifier': ruleForLocationOfGoodsAdditionalIdentifier,
  'locationOfGoods.address': ruleForLocationOfGoodsAddress,
  'locationOfGoods.address.addressLine': ruleForLocationOfGoodsAddressAddressLine,
  'locationOfGoods.address.city': ruleForLocationOfGoodsAddressCity,
  'locationOfGoods.address.country': ruleForLocationOfGoodsAddressCountry,
  'locationOfGoods.address.postcode': ruleForLocationOfGoodsAddressPostcode,
  'locationOfGoods.address.street': forbidden,
  'locationOfGoods.address.streetNumber': forbidden,
  'locationOfGoods.contactPerson': ruleForLocationOfGoodsContactPerson,
  'locationOfGoods.economicOperatorIdentificationNumber': ruleForLocationOfGoodsEconomicOperatorIdentificationNumber,
  'locationOfGoods.gnss': ruleForLocationOfGoodsGnss,
  'locationOfGoods.postcodeAddress': ruleForLocationOfGoodPostcodeAddress,
  'locationOfGoods.postcodeAddress.houseNumber': ruleForLocationOfGoodPostcodeAddressHouseNumber,
  'locationOfGoods.qualifierOfIdentification': ruleForLocationOfGoodsQualifierOfIdentification,
  'locationOfGoods.referenceNumber': ruleForLocationOfGoodsReferenceNumber,
  'locationOfGoods.typeOfLocation': ruleForLocationOfGoodsTypeOfLocation,
  'locationOfGoods.unLocode': ruleForLocationOfGoodsUnLocode,
  placeOfAcceptance: forbidden,
  placeOfDelivery: forbidden,
  placeOfLoading: ruleForLoading,
  'placeOfLoading.location': ruleForPlaceOfLoadingLocation,
  'placeOfLoading.country': ruleForPlaceOfLoadingCountry,
  'placeOfLoading.unLocode': forbidden,
  placeOfUnloading: ruleForUnloading,
  'placeOfUnloading.location': ruleForPlaceOfUnloadingLocation,
  'placeOfUnloading.country': ruleForPlaceOfUnloadingCountry,
  'placeOfUnloading.unLocode': forbidden,
  'previousDocument.*.documentType': required,
  'previousDocument.*.referenceNumber': required,
  referenceNumberUCR: ruleForReferenceNumberUCR,
  security: required,
  specificCircumstanceIndicator: forbidden,
  'supportingDocument.*.documentType': required,
  'supportingDocument.*.referenceNumber': required,
  transportChargesMethodOfPayment: forbidden,
  'transitCustomsOffices.*.arrivalDateAndTime': ruleForTransitCustomsOfficeDateTime,
  'transitCustomsOffices.*.entryIndicator': forbidden,
  'transitCustomsOffices.*.reEntryIndicator': forbidden,
  'transportDocument.*.documentType': required,
  'transportDocument.*.referenceNumber': required,
  transportEquipment: ruleForTransportEquipment,
  'transportEquipment.*.containerIdentificationNumber': ruleForContainerIdentificationNumber,
  'transportEquipment.*.containerSizeAndType': forbidden,
  'transportEquipment.*.goodsReferences': ruleForGoodsReferences,
  'transportEquipment.*.goodsReferences.*.consignmentItemId': required,
  'transportEquipment.*.seals.*.identifier': required,
  'transportEquipment.*.packedStatus': forbidden,
  'transportEquipment.*.supplierType': forbidden,
}

function getServerRequirementForPath(
  path: string,
  ctx: FieldRequirementResolverContext,
) {
  return matchServerRequirement(ctx.serverValidationResult?.fieldRequirements, path)
}

const getFieldRequirementP5 = createFieldRequirementGetter<FieldRequirementResolverContext>(
  fieldRequirementResolversP5,
  getServerRequirementForPath,
)

export default getFieldRequirementP5
